import { useRef } from 'react'
import { type SelectChangeEvent } from '@mui/material'
import { Select, type SelectProps } from '@dhl-ui/components'
import { useField, useFormikContext } from './shared'
import { type WithRequired } from './types'

export type SelectInputProps<T> = WithRequired<Omit<SelectProps<T>, 'onChange'>, 'name' | 'label'> & {
  onChange?: (value: T) => void
}

/** @deprecated: move towards react-hook-form */
export const SelectInput = <T,>({ name, helperText, onChange: propagateOnChange, ...props }: SelectInputProps<T>) => {
  const [field, meta, helpers] = useField<T>(name)
  const { isSubmitting, validateOnChange } = useFormikContext<T>()
  const inputRef = useRef<HTMLInputElement>(null)

  const onChange = (e: SelectChangeEvent<T>) => {
    const fieldValues = e.target.value as T
    helpers.setTouched(true)
    helpers.setValue(fieldValues, validateOnChange)
    propagateOnChange?.(fieldValues)
  }

  return (
    <Select
      {...props}
      {...field}
      name={name}
      error={!!meta.error && meta.touched}
      helperText={meta.touched && meta.error?.trim() ? meta.error : helperText}
      inputRef={inputRef}
      onChange={onChange}
      disabled={props.disabled || isSubmitting}
    />
  )
}
